<template>
  <div>
    <search-form @setSearchConditionMakeout="setSearchConditionMakeout" @clearSearch="clearSearch"></search-form>
    <div class="table-operator">
      <template>
        <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      </template>
<!--      <template v-if="$auth('invoice.deleteReceive')">-->
<!--        <a-popconfirm title="确定要删除这些记录吗?" ok-text="确定" cancel-text="取消" @confirm="handleDelete()">-->
<!--          <a-button>批量删除</a-button>-->
<!--        </a-popconfirm>-->
<!--      </template>-->
    </div>
    <zm-table
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :pagination="pagination"
      :loading="table.loading"
      showSorterTooltip
      @change="handleTableChange"
    >
      <template v-slot:actions="{ text, record }">
        <template>
          <a href="javascript:;" @click="() => handleEdit(record)">编辑</a>
        </template>
        <template>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="() => handleView(record)">详情</a>
        </template>
        <template>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除该条记录吗?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a href="javascript:;" style="color: red">删除</a>
          </a-popconfirm>
        </template>
      </template>
    </zm-table>

    <makeout-modal ref="makeoutModal" @refreshTable="initTableData"></makeout-modal>
  </div>
</template>

<script>
import moment from 'moment'
import makeoutModal from './makeoutModal'
import searchForm from './searchForm'
import { getInvoiceList, deleteInvoice } from '@/api/business/invoice'

export default {
  name: 'MakeoutTable',

  computed: {},
  components: {
    makeoutModal,
    searchForm
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            align: 'center',
            width: 70,
            customRender: (text, record, index) => `${index + 1}`
          },
          {
            title: '开票编号',
            dataIndex: 'invoiceNo'
          },
          {
            title: '合同名称',
            dataIndex: 'contractName'
          },
          {
            title: '开票比例',
            dataIndex: 'ratioNum'
          },
          {
            title: '开票金额(元)',
            dataIndex: 'invoiceMoney'
          },
          {
            title: '税点',
            dataIndex: 'taxPointName'
          },
          {
            title: '开票日期',
            dataIndex: 'invoiceTime',
            customRender: text => {
              return moment(text).format('YYYY-MM-DD')
            }
          },
          {
            title: '甲方名称',
            dataIndex: 'companyName'
          },
          {
            title: '经办人',
            dataIndex: 'operatorName'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'center',
            fixed: 'right',
            width: 200
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
  },
  methods: {
    // 搜索
    setSearchConditionMakeout (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.table.filteredInfo = null
      this.table.sortedInfo = null
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 初始化表格数据
    initTableData () {
      this.table.loading = true
      this.searchModel.type = 2

      getInvoiceList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.table.filteredInfo = filters
      this.table.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination,
        ...this.searchTableModel
      }
      this.initTableData()
    },
    // 删除操作
    // setStatus (model, type) {
    //   modifyProprietorsStatus({
    //     id: model.id,
    //     status: type
    //   }).then(res => {
    //     if (res.status === 0) {
    //       this.$message.success(res.info.message)
    //       this.initTableData()
    //     } else {
    //       this.$message.error(res.info.message)
    //     }
    //   })
    // },
    // 查看详情
    handleView (model) {
      this.$refs.makeoutModal.setTitle('查看开票信息')
      this.$refs.makeoutModal.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.makeoutModal.setModel(model) // 先设置类型，再打开
      this.$refs.makeoutModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.makeoutModal.setTitle('编辑开票信息')
      this.$refs.makeoutModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.makeoutModal.setModel(model) // 先设置类型，再打开
      this.$refs.makeoutModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.makeoutModal.setTitle('新增开票信息')
      this.$refs.makeoutModal.setType(this.$sysInfo.MODAL_ADD) // 先设置类型，再打开
      this.$refs.makeoutModal.open(true)
    },
    // 锁定
    handleLock (model) {
      this.$refs.makeoutModal.setTitle('锁定开票信息')
      this.$refs.makeoutModal.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.makeoutModal.setModel(model) // 先设置类型，再打开
      this.$refs.makeoutModal.open(true)
    },
    // 删除
    handleDelete (model) {
      let ids
      if (model) {
        ids = model.id
      } else {
        ids = this.selectedRows.map(item => item.id).join(',')
      }

      deleteInvoice({ ids }).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    }
  }
}
</script>
